const SHARE_INVITE_STORAGE_KEY = 'ltw-share-invite';
const SHARE_INVITE_TTL_MS = 24 * 60 * 60 * 1000;
const SHARE_INVITE_CODE_PATTERN = /^[A-Za-z0-9_-]+$/;

export function isValidShareInviteCode(code) {
    return typeof code === 'string' && SHARE_INVITE_CODE_PATTERN.test(code);
}

export function storeShareInvite(shareInvite) {
    if (!isValidShareInviteCode(shareInvite?.code)) {
        return;
    }

    try {
        window.localStorage.setItem(
            SHARE_INVITE_STORAGE_KEY,
            JSON.stringify({
                ...shareInvite,
                storedAt: Date.now(),
            })
        );
    } catch (error) {
        console.error('Failed to store share invite context', error);
    }
}

export function getStoredShareInvite() {
    try {
        const rawValue = window.localStorage.getItem(SHARE_INVITE_STORAGE_KEY);

        if (!rawValue) {
            return null;
        }

        const parsedValue = JSON.parse(rawValue);

        if (parsedValue?.storedAt && Date.now() - parsedValue.storedAt > SHARE_INVITE_TTL_MS) {
            clearStoredShareInvite();
            return null;
        }

        return isValidShareInviteCode(parsedValue?.code) ? parsedValue : null;
    } catch (error) {
        console.error('Failed to read share invite context', error);
        return null;
    }
}

export function clearStoredShareInvite() {
    try {
        window.localStorage.removeItem(SHARE_INVITE_STORAGE_KEY);
    } catch (error) {
        console.error('Failed to clear share invite context', error);
    }
}
